export default __webpack_public_path__ + "static/15-c0e704711882524aa8e80316602d2323.png";